import * as $ from "jquery";
import tippy, { Instance, Props } from "tippy.js";

import "./main.scss";

const APP_CONFIGURATION = {
  document: {
    init: "data-init",
  },
  header: {
    sticky: "data-sticky",
  },
  collapsable: {
    init: "data-init",
    attribute: "data-collapse",
  },
  menu: {
    attribute: "data-shown",
    contacts: {
      attribute: "data-contacts",
    },
  },
  anchor: {
    attribute: "data-anchor-id",
    attributeTarget: "data-anchor-target",
    generalAttribute: "data-anchor",
  },
};

namespace WebApplication {
  function buildSlideshow(images: string[], selected: string) {
    const sliderShowOuter = $("<div />").addClass("slideshow-outer");

    const topControls = $("<div />")
      .addClass("top-controls")
      .append($("<div />").addClass("orion-font-cancel-1"))
      .on("click", () => sliderShowOuter.remove());

    const leftNav = $("<div />")
      .addClass("navigator")
      .addClass("navigator-left")
      .append(
        $("<div />")
          .addClass("orion")
          .append($("<div />").addClass("orion-font-navigation-down-1"))
      )
      .on("click", () => {
        const imageElements = slider.children();
        const indexOf = imageElements.filter('[data-visible="true"]').index();

        const nextIndex = (images.length + indexOf - 1) % images.length;

        imageElements
          .attr("data-visible", "false")
          .eq(nextIndex)
          .attr("data-visible", "true");
      });

    const rightNav = $("<div />")
      .addClass("navigator")
      .addClass("navigator-right")
      .append(
        $("<div />")
          .addClass("orion")
          .append($("<div />").addClass("orion-font-navigation-down-1"))
      )
      .on("click", () => {
        const imageElements = slider.children();
        const indexOf = imageElements.filter('[data-visible="true"]').index();

        const nextIndex = (images.length + indexOf + 1) % images.length;

        imageElements
          .attr("data-visible", "false")
          .eq(nextIndex)
          .attr("data-visible", "true");
      });

    const slider = $("<div />").addClass("slider");

    for (let image of images) {
      $("<div />")
        .addClass("image")
        .attr("data-visible", String(selected === image))
        .append($("<img />").prop("src", image))
        .appendTo(slider);
    }

    const slideshowInner: JQuery = $("<div />")
      .addClass("slideshow-inner")
      .append(topControls)
      .append(leftNav)
      .append(slider)
      .append(rightNav);

    return sliderShowOuter.append(slideshowInner).appendTo("body");
  }

  function initGallery(gallery: JQuery) {
    const urlExtractor: (img: HTMLElement) => string = (img) => {
      return $(img)
        .css("background-image")
        .replace('url("', "")
        .replace('")', "");
    };

    gallery.find(".image-preview").on("click", function () {
      const images = Array.from(gallery.find(".image-preview")).map((img) =>
        urlExtractor(img)
      );

      buildSlideshow(images, urlExtractor(this));
    });
  }

  function initCollapsable(element: JQuery) {
    element.attr(APP_CONFIGURATION.collapsable.init, "");

    const placeholder = element.find(".placeholder-container");

    if (!placeholder) return;

    placeholder.on("click", function () {
      const isCollapse =
        element.attr(`${APP_CONFIGURATION.collapsable.attribute}`) === "true";
      element.attr(
        `${APP_CONFIGURATION.collapsable.attribute}`,
        isCollapse ? "false" : "true"
      );

      placeholder
        .closest(".service")
        .siblings()
        .attr(`${APP_CONFIGURATION.collapsable.attribute}`, "true");
    });
  }

  function initMenu() {
    const menuToggleFunction = () => {
      const isShown =
        $("nav .menu-outer-container").attr(
          APP_CONFIGURATION.menu.attribute
        ) === "true";

      if (isShown) {
        menuCloseFunction();
      } else {
        menuOpenFunction();
      }
    };

    const menuOpenFunction = () => {
      $("nav .menu-outer-container").attr(
        APP_CONFIGURATION.menu.attribute,
        "true"
      );
    };

    const menuCloseFunction = () => {
      $("nav .menu-outer-container").attr(APP_CONFIGURATION.menu.attribute, "");
    };

    const subMenuList = Array.from($("nav .navbar-container .sub-menu"));
    for (let submenu of subMenuList) {
      const label = $(submenu).parent().children("a");

      if (!label) continue;

      const icon = $("<div />")
        .addClass("orion-font-navigation-down-1")
        .appendTo(label);

      label.addClass("menu-item-sub");
    }

    const menuItems = Array.from($(".menu-item"));
    const location = window.location;
    const currentURL = location.href;
    const hostname = location.hostname;

    const resource = currentURL.split(hostname, -1)[1];

    if (!resource || resource !== "/#") {
      for (let menuItem of menuItems) {
        const menuItemLink = $(menuItem).children("a");
        const href = menuItemLink.prop("href");

        if (href === currentURL) {
          menuItemLink.addClass("active");
        }

        if (href.split[1] === "/") {
          menuItemLink.parent().addClass("menu-item-home");
        }
      }
    }

    $("nav .navbar-container .col-menu-toggle").on("click", menuToggleFunction);

    $("nav .navbar-container .col-menu-close").on("click", menuCloseFunction);

    $(`nav [${APP_CONFIGURATION.menu.contacts.attribute}]`).on("click", () => {
      menuCloseFunction();

      $(".section-contact")
        .get(0)
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  function initAnchors() {
    const anchors = Array.from($(".anchors > .anchor"));

    const scrollIntoView: (target: HTMLElement) => void = (target) => {
      if (!target) return;

      requestAnimationFrame(() =>
        target.scrollIntoView({ behavior: "smooth", block: "center" })
      );
    };

    for (let anchor of anchors) {
      $(anchor).on("click", () => {
        const id = $(anchor).attr(APP_CONFIGURATION.anchor.attribute);
        const target = $(
          `[${APP_CONFIGURATION.anchor.attributeTarget}="${id}"]`
        );

        scrollIntoView(target.get(0));
      });
    }

    const generalAnchors = Array.from(
      $(`[${APP_CONFIGURATION.anchor.generalAttribute}]`)
    );
    for (let anchor of generalAnchors) {
      $(anchor).on("click", () => {
        const selector = anchor.getAttribute(
          APP_CONFIGURATION.anchor.generalAttribute
        );
        const target = document.querySelector(selector);

        scrollIntoView(target as HTMLElement);
      });
    }
  }

  export function initScroll() {
    const onScroll = () => {
      const header = $("header");

      header.attr(APP_CONFIGURATION.header.sticky, String(window.scrollY > 0));
    };

    window.addEventListener("scroll", onScroll);
  }

  export function init() {
    initMenu();

    const collapsableList = Array.from(
      $(`[${APP_CONFIGURATION.collapsable.attribute}]`)
    );

    for (const element of collapsableList) {
      initCollapsable($(element));
    }

    initAnchors();

    initScroll();

    /*const galleryList = Array.from($(`.gallery-preview`));
    for (const element of galleryList) {
      initGallery($(element));
    }*/
  }
}

jQuery(function () {
  WebApplication.init();
});
